import { render, staticRenderFns } from "./ConfirmationTypeTooltip.vue?vue&type=template&id=7fce8f32&scoped=true&"
import script from "./ConfirmationTypeTooltip.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ConfirmationTypeTooltip.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ConfirmationTypeTooltip.vue?vue&type=style&index=0&id=7fce8f32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fce8f32",
  null
  
)

export default component.exports